import type { TOC } from '@ember/component/template-only';

import CommonFullscreenLoaderComponent from 'webapp/components/common/fullscreen-loader';

const BoardsTabsLoadingRouteTemplate: TOC<object> = <template>
	<CommonFullscreenLoaderComponent />
</template>;

export default BoardsTabsLoadingRouteTemplate;
